export default "__VITE_PUBLIC_ASSET__bd2e7276__"